export class QPaperMergeGerReqModel {
    classId: number;
    userId: number;
    subjectIds: number[];
    constructor(classId: number, userId: number, subjectIds: number[]) {
        this.classId = classId;
        this.userId = userId;
        this.subjectIds = subjectIds;
    }
}